import React, { type ReactNode, useMemo, createContext, useContext } from 'react';

type PanelDataContextProps = {
	isCompanyManaged: boolean;
	boardId: number;
	sourceDroppableType: string;
};
const PanelDataContext = createContext<PanelDataContextProps>({
	isCompanyManaged: false,
	boardId: -1,
	sourceDroppableType: '',
});

// Code shared between epic and version panels should ideally live in a shared package
export const PanelDataProvider = ({
	children,
	isCompanyManaged,
	boardId,
	sourceDroppableType,
}: PanelDataContextProps & { children: ReactNode }) => {
	const panelData = useMemo(
		() => ({
			isCompanyManaged,
			boardId,
			sourceDroppableType,
		}),
		[boardId, isCompanyManaged, sourceDroppableType],
	);

	return <PanelDataContext.Provider value={panelData}>{children}</PanelDataContext.Provider>;
};
export const usePanelData = () => useContext(PanelDataContext);
